import useShadowWrapper from './shadow-wrapper-detect';

const defineShadowWrapper = () => {
   if (!useShadowWrapper) {
      return;
   }

   if (customElements.get('shadow-wrapper')) {
      return;
   }

   customElements.define(
      'shadow-wrapper',
      class extends HTMLElement {
         theShadowRoot;

         constructor() {
            super();

            this.querySelectorAll('[data-no-shadow]').forEach(node => {
               this.parentNode.appendChild(node);
            });

            this.theShadowRoot = this.attachShadow({ mode: 'closed' });
            [...Array.from(this.children)].forEach(node => {
               this.theShadowRoot.appendChild(node);
            });
         }

         queryAll($selector: any) {
            return this.theShadowRoot.querySelectorAll($selector);
         }
      }
   );
};

defineShadowWrapper();
